import React, { Component } from "react";
import { encryptData } from "./utils/encryptionUtils";
import { getClientId } from "./utils/analyticsclientIdUtils";

import ZPartnerLSC0Header from "./ZPartnerLSC0Header";
import ZPartnerLSC0Footer from "./ZPartnerLSC0Footer";

import { Redirect_Url_1 } from "./ZPartnerLSCUrls";

export class LSC_Signin extends Component {
    static displayName = LSC_Signin.name;

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            loginstatus: "",
            requireMsgEmail: "",
            requireMsgPwd: "",
            submitting: false,
            uid: "",
            checkLogin: "",
            oneTimeKey: ""
        };
    }

    componentDidMount() {
        //const links = [
        //    "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
        //    "/css/lsc/style_01.css",
        //    "/css/lsc/style_02.css",
        //    "/css/lsc/style_03.css",
        //    "/css/lsc/691208892_en-US.css",
        //    "/css/lsc/line_my_card.css"
        //];

        //links.forEach(href => {
        //    const link = document.createElement("link");
        //    link.rel = "stylesheet";
        //    link.href = href;
        //    document.head.appendChild(link);
        //});

        // Read query string parameters
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("uid");
        const checkLogin = params.get("checkLogin");
        const oneTimeKey = params.get("oneTimeKey");

        // If any required parameter is missing, redirect to error page
        if (!uid || !checkLogin || !oneTimeKey) {
            sessionStorage.setItem("lscErrorMsg", "Missing param!!");
            window.location.replace("/line_err01");
            return;
        }

        // Save query values into state
        this.setState({ uid, checkLogin, oneTimeKey });

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "LSC_Signin";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    // Email validation
    validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        const { email, password, uid, checkLogin, oneTimeKey } = this.state;

        let canSubmit = true;

        // Reset messages
        this.setState({
            requireMsgEmail: "",
            requireMsgPwd: "",
            loginstatus: ""
        });

        // Validate email
        if (!email) {
            this.setState({ requireMsgEmail: "Enter an email" });
            canSubmit = false;
        } else if (!this.validateEmail(email)) {
            this.setState({ requireMsgEmail: "Please enter valid Email" });
            canSubmit = false;
        }

        // Validate password
        if (!password) {
            this.setState({ requireMsgPwd: "Enter a password" });
            canSubmit = false;
        }

        if (!canSubmit) {
            return;
        }

        // Prevent double submit
        this.setState({ submitting: true });
        document.body.classList.add("wait-cursor");

        const timestamp = Math.floor(Date.now() / 1000);

        // Payload for Line Signin
        const payload = {
            Email: email,
            Password: password,
            Uid: uid,
            CheckLogin: checkLogin,
            OneTimeKey: oneTimeKey,
            RefLang: "en",
            Timestamp: timestamp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/ZPartnerLSCSignin`, requestOptions);
            const data = await response.json();
            
            if (data.responseCode === "00") {
                const message = (data.responseMessage || "").toLowerCase();
                sessionStorage.setItem("signinMessage", message);

                document.body.classList.remove("wait-cursor");

                // Redirect after successful signin
                switch (message) {
                    case "success":
                        window.location.replace(Redirect_Url_1);
                        break;                    
                    case "success2":
                        window.location.replace("/line_signin_replace");
                        break;
                    case "error-uidsigninmissmatch":
                        window.location.replace("/line_signin_uid_mismatch");
                        break;
                    case "error-toomanyactivatevirtualcard":
                        sessionStorage.setItem("lscErrorMsg", "Too many Activate VirtualCard!!");
                        window.location.replace("/line_err01");
                    case "error-addcardtoaccount":
                        sessionStorage.setItem("lscErrorMsg", "Error AddCardToAccount");
                        window.location.replace("/line_err01");
                    default:
                        window.location.replace("/line_signin_success");
                        break;
                }           
            } else {
                const message = data.responseMessage || "Login failed";

                let t01 = message + "[ " + message
                    .replace("Invalid Email or Password ", "อีเมลหรือรหัสผ่านไม่ถูกต้อง สามารถใส่ได้อีกไม่เกิน ")
                    .replace(" more attempts your account will be locked for ", " ครั้ง หากยังไม่ถูกต้องบัญชีของคุณจะถูกล็อกเป็นเวลา ")
                    .replace(" hours", " ชั่วโมง")
                    .replace("Invalid username or password", "อีเมลหรือรหัสผ่านไม่ถูกต้อง")
                    .replace(
                        "Your account had been locked because you have reached the maximum number of invalid login attempts.",
                        "อีเมลหรือรหัสผ่านไม่ถูกต้อง บัญชีของคุณจะถูกล็อกเป็นเวลา 1 ชั่วโมง"
                ) + " ]";

                this.setState({
                    loginstatus: t01,
                    submitting: false
                });

                document.body.classList.remove("wait-cursor");
            }
        } catch (error) {
            console.error("Error during LineSignin API:", error);
            this.setState({
                loginstatus: "Unexpected error occurred",
                submitting: false
            });

            document.body.classList.remove("wait-cursor");
        }
    };

    render() {
        const {
            uid,
            email,
            password,
            submitting,
            loginstatus,
            requireMsgEmail,
            requireMsgPwd
        } = this.state;

        if (!uid) {
            return (
                <div>
                    ...
                </div>
            );
        }

        return (
            <>
                <ZPartnerLSC0Header />

                <main id="main">                    
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121">เข้าสู่ระบบ<br />
                                        Sign in</h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <form className="form-sr px-1 px-md-4" onSubmit={this.handleSubmit}>
                                            <div className="mb-4">
                                                <label htmlFor="exampleInputEmail1" className="form-label d-none">อีเมล / Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="อีเมล / Email"
                                                    name="email"
                                                    value={email}
                                                    onChange={this.handleChange}
                                                />
                                                {requireMsgEmail}
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="exampleInputPassword1" className="form-label d-none">Password</label>
                                                <div className="input-group mb-3">                                                    
                                                    <input
                                                        type="password"
                                                        className="form-control border-end-0"
                                                        placeholder="รหัสผ่าน / Password"
                                                        name="password"
                                                        value={password}
                                                        onChange={this.handleChange}
                                                    />
                                                    <span className="input-group-text"><i toggle="#password-field" className="fa fa-fw fa-eye-slash toggle-password" /></span>
                                                </div>
                                                {requireMsgPwd}
                                            </div>
                                            <div className="text-center">                                                
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary rounded-pill px-4"
                                                    disabled={submitting}
                                                >
                                                    <span className="text-sm Sarabun_fontthai text-bold">
                                                        {submitting ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
                                                    </span>
                                                    <br />
                                                    <span className="text-xxs text-bold">
                                                        {submitting ? "Signing in..." : "Sign in"}
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="text-center">
                                                <div className="req text-danger">
                                                    {loginstatus}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>                

                <ZPartnerLSC0Footer />
            </>
        );
    }
}
